import { ActivityLogWithDescriptions } from '../../models/ActivityLog';

/** Flatten API response items so ActivityLogEntry receives eventType, extendedInfoPath, etc. at top level. */
export function normalizeActivityLogItem(
  item: ActivityLogWithDescriptions | Record<string, unknown>,
): Record<string, unknown> {
  const withDesc = item as ActivityLogWithDescriptions;
  if (withDesc?.log && typeof withDesc.log === 'object') {
    return {
      ...withDesc.log,
      associatedModelDescription:
        withDesc.associatedModelDescription ?? (withDesc.log as any).associatedModelDescription,
      initiatedByDescription:
        withDesc.initiatedByDescription ?? (withDesc.log as any).initiatedByDescription,
      linkedModelDescriptions:
        withDesc.linkedModelDescriptions ??
        (withDesc.log as any).linkedModelsWithDescriptions ??
        (withDesc.log as any).linkedModels ??
        [],
    } as Record<string, unknown>;
  }
  return item as Record<string, unknown>;
}

export type ActivityLogPageFilters = {
  eventType: string | string[];
  initiatedByType: string;
  initiatedByExternalId: string | string[];
  associatedModelType: string | string[];
  associatedModelExternalId: string | string[];
  linkedModelType: string | string[];
  linkedModelExternalId: string | string[];
  startDate: string;
  endDate: string;
};

export const emptyActivityLogPageFilters: ActivityLogPageFilters = {
  eventType: '',
  initiatedByType: '',
  initiatedByExternalId: '',
  associatedModelType: '',
  associatedModelExternalId: '',
  linkedModelType: '',
  linkedModelExternalId: '',
  startDate: '',
  endDate: '',
};

export function getActiveActivityLogPageFilters(
  filters: ActivityLogPageFilters,
): Partial<ActivityLogPageFilters> {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => {
      if (value === '') return false;
      if (Array.isArray(value)) return value.length > 0;
      return true;
    }),
  ) as Partial<ActivityLogPageFilters>;
}
